import {
    useBlockProps,
    ColorPalette,
    InspectorControls,
    InnerBlocks,
    BlockControls,
    AlignmentToolbar,
    MediaUpload,
    MediaUploadCheck
} from '@wordpress/block-editor';

const colors = [ {name:"Black",color:'#000'},
    {name:"White",color:'#fff'},
    {name:"Transparent",color:'#fcfcfc'},
    {name:"Light Yellow",color:'#fff9f2'},
    {name:"Light Grey",color:'#ececec'},
    
    {name:"Teal",color:'#00a2af'},
    {name:"Light Blue",color:'#ebf5fe'},
    {name:"Blue",color:'#195b95'},
    {name:"Yellow",color:'#f0e18d'},

    {name:"Green",color:'#b8be36'}];

export default function PMGColorPalette({value,onChange}){

    return (<ColorPalette
        value={value}
        colors={colors}
        onChange={(v)=>{
            onChange(v,colors.find(c=>(c.color == v))?.name);
        }}
    />);

}

export const fontColorAssociations = {
    "transparent":"transparent",
    "#000":"#fff",
    "#fff":"#000",
    "#fcfcfc":"#000000",
    "#fff9f2":"#000000",
    "#ececec":"#000000",
    "#00a2af":"#ffffff",
    "#b65943":"#ffffff",
    "#423133":"#ffffff",
    "#f0e18d":"#000000",
    "#b8be36":"#ffffff"

}
